@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.step-container {
  color: @onboarding-page--text-color;
  padding: 32px 24px;
  display: flex;
  background-color: @onboarding-page--container--background-color;
  flex-direction: column;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.05);

  @media @tablet, @desktop, @widescreen, @ultrawide {
    border: 1px solid @onboarding-page--step--border-color;
    border-radius: 4px;
    padding: 24px;
    flex-direction: row;
    box-shadow: none;
  }

  &.is-marketplace {
    flex-direction: column;
    gap: 10px;

    .step-header {
      @media @tablet, @desktop, @widescreen, @ultrawide {
        align-items: flex-start;
      }
      @media @mobile {
        flex-direction: column;
      }
    }
  }

  .step-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 60px;

    .step-title-and-message-below {
      width: 550px;
    }

    .step-action-container {
      width: 100%;
    }
  }

  .step-text-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .step-text-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h3 {
      margin: 0 0 8px;
      font-size: 20px;
      font-weight: @normal;
      line-height: 25px;
      color: @onboarding-page--title--text-color;
    }
  }

  .step-row-container {
    display: flex;
    text-align: center;
    justify-content: center;
  }

  .icon {
    height: 64px;
    width: 64px;
    color: @onboarding-page--fill-color;
  }

  .completed {
    line-height: 18px;
    margin-bottom: 11px;
    color: @onboarding-page--completed--text-color;
    font-weight: @bold;
    font-size: 12px;
  }

  .check-icon {
    padding-right: 5px;
    width: 16px;
    height: 12px;
    fill: @onboarding-page--completed--text-color;
  }

  .emoji {
    margin-left: 5px;
  }

  /*added for the select label icon on the onboard page*/
  .step-row .icon g {
    /* stylelint-disable-line */
    fill: @onboarding-page--fill-color;
  }

  .step-description {
    width: 100%;
    color: @onboarding-page--description--text-color;
    font-size: 14px;
    margin-bottom: 24px;
    line-height: 21px;
  }

  .step-action-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;

    @media @tablet, @desktop, @widescreen, @ultrawide {
      min-width: 220px;
      align-items: end;
      text-align: end;
    }
  }

  .add-button {
    font-weight: 500;
    margin-bottom: 3px;
    height: 48px;
    width: 100%;

    @media @tablet, @desktop, @widescreen, @ultrawide {
      height: 30px;
      max-width: 175px;
    }
  }

  .add-another-button {
    margin-top: 4px;
    white-space: nowrap;
    font-weight: @normal;
    font-size: 12px;
    line-height: 20px;
  }

  .manual-CSV {
    font-size: 12px;
  }

  .manual-CSV-rate-browser {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
  }
}
